import { useState } from 'react';
import { CheckSquare, Square } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button, Tooltip } from 'reactstrap';

import * as authSelectors from '@redux/reducers/auth';

interface Props {
  isDisabled?: boolean;
  permissions?: any[];
  handleClick: any;
  tooltipMessage?: string;
  checked?: boolean;
}

const CheckSquareButton = (props: Props) => {
  const store = useSelector((state) => state);
  const { isDisabled, handleClick, tooltipMessage, permissions, checked = true } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return !permissions || authSelectors.getAuthUserHasPermissionsAny(store, permissions) ? (
    <Button.Ripple
      id={`checkSquare${checked}Button`}
      className={`btn-icon ${isDisabled ? 'disabled' : ''}`}
      color="secondary"
      disabled={isDisabled}
      onClick={() => handleClick()}
    >
      {checked ? <CheckSquare size={16} /> : <Square size={16} />}
      <Tooltip
        placement="top"
        isOpen={tooltipOpen}
        target={`checkSquare${checked}Button`}
        toggle={toggle}
      >
        <FormattedMessage id={tooltipMessage} />
      </Tooltip>
    </Button.Ripple>
  ) : null;
};

CheckSquareButton.defaultProps = {
  isDisabled: false
};

export default CheckSquareButton;
